import { cn } from '@/lib/utils';

export function PulseDot({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-block size-2 rounded-full bg-accent animate-pulse-dot',
        'shadow-[0_0_12px_var(--accent)]',
        className,
      )}
      aria-hidden
    />
  );
}
